import { render } from "./SafcoTables.vue?vue&type=template&id=1edcf49e&scoped=true"
import script from "./SafcoTables.vue?vue&type=script&lang=js"
export * from "./SafcoTables.vue?vue&type=script&lang=js"

import "./SafcoTables.vue?vue&type=style&index=0&id=1edcf49e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1edcf49e"]])

export default __exports__